import LayerTypes from '../enums/layerTypes';

const CURSOR_CLASS = 'nhs-u-cursor--pointer';
const CURSOR_LAYER_SELECTOR = [LayerTypes.LotPolygons, LayerTypes.LotNumbers]
  .map((type) => `[data-layer-type="${type}"]`)
  .join(', ');

/**
 * Creates interaction handlers for lot polygon events emitted by the SVG overlay.
 *
 * The plugin adapts the raw facade event signatures (which operate at site-plan/community
 * granularity) to a normalized { lotId } shape before calling these handlers, so that
 * future per-lot delegation can be wired here without changing the plugin.
 *
 * @returns {{ onLotHover: Function, onLotClick: Function, onLotEnter: Function, onLotLeave: Function }}
 */
export function createLotPolygonInteractionHandlers() {
  return {
    onSvgReady(svgElement) {
      svgElement.classList.add('nhs-u-absolute', 'nhs-u-pointer-events--all');
      svgElement.querySelectorAll('path:not([id])').forEach((path) => {
        if (!path.closest('[id]')) {
          path.classList.add('nhs-u-pointer-events--none');
        }
      });
    },
    onLotEnter({ target, svgElement }) {
      svgElement.classList.toggle(CURSOR_CLASS, !!target.closest(CURSOR_LAYER_SELECTOR));
    },
    onLotLeave({ svgElement }) {
      svgElement.classList.remove(CURSOR_CLASS);
    },
    onLotHover({ lotId }) {
      // TODO: lot hover functionality should be placed here when developed.
      return lotId;
    },
    onLotClick({ lotId }) {
      // TODO: lot click functionality should be placed here when developed.
      return lotId;
    },
  };
}

export default createLotPolygonInteractionHandlers;
